import {css} from "lit";

export default [css`
	button {
		display: flex;
		justify-content: center;
		align-items: center;

		position: fixed;
		bottom: 10px;
		right: 24px;
		width: 60px;
		height: 60px;
		margin: 14px 0;

		cursor: pointer;
		border-radius: 50% ! important;
		box-shadow: 0 0 15px var(--pn-sidebar-close-shadow-color);
		border: 0;
		background: var(--pn-sidebar-close-bg-color);
		transition: all 0.5s;
	}

	button:active, button:hover, button:focus {
		box-shadow: 0 0 15px var(--pn-sidebar-close-shadow-color-hover) !important;
		transition: all 0.5s;
	}

	button:focus-visible {
		outline: 2px dashed var(--pn-sidebar-toggle-shadow-color) -hover;
		transition: none;
	}
`];
